import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_long-arrow",
  "use": "svg_long-arrow-usage",
  "viewBox": "0 0 25 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 18\" id=\"svg_long-arrow\"><path d=\"m24.707 8.293-8-8A.999.999 0 0 0 15 1c0 .276.111.526.293.707L21.586 8H1a1 1 0 1 0 0 2h20.586l-6.293 6.293a1 1 0 1 0 1.414 1.414l8-8a.997.997 0 0 0 0-1.414Z\" style=\"stroke-linecap:round;stroke-linejoin:round;fill-rule:evenodd\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol